import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Home,
  LayoutDashboard,
  Settings,
  Users,
  FileText,
  BarChart3,
  X,
} from 'lucide-react';

const menuItems = [
  { icon: Home, labelKey: 'navigation.home', path: '/' },
  { icon: LayoutDashboard, labelKey: 'navigation.dashboard', path: '/dashboard' },
  { icon: BarChart3, labelKey: 'navigation.analytics', path: '/analytics' },
  { icon: Users, labelKey: 'navigation.users', path: '/users' },
  { icon: FileText, labelKey: 'navigation.documents', path: '/documents' },
  { icon: Settings, labelKey: 'navigation.settings', path: '/settings' },
];

export const Sidebar = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  
  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:sticky top-0 left-0 z-50
          h-screen w-64 bg-white border-r border-gray-200
          transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        <div className="flex flex-col h-full">
          {/* Mobile close button */}
          <div className="lg:hidden flex items-center justify-between p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">{t('navigation.menu')}</h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="h-5 w-5 text-gray-600" />
            </button>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto p-4 space-y-1 scrollbar-thin">
            {menuItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => onClose()}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-primary-700 font-medium'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`
                }
              >
                <item.icon className="h-5 w-5 flex-shrink-0" />
                <span>{t(item.labelKey)}</span>
              </NavLink>
            ))}
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-gray-200">
            <div className="bg-primary-50 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-primary-900 mb-1">
                {t('header.needHelp')}
              </h3>
              <p className="text-xs text-primary-700 mb-3">
                {t('header.checkDocumentation')}
              </p>
              <button className="text-xs font-medium text-primary-600 hover:text-primary-700">
                {t('header.viewDocs')}
              </button>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};
